import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Selectors/Select/mobile';

import { formatePoints } from 'features/bonusProgram/data/formatePoints';
import { statuses } from 'features/bonusProgram/data';

import './GiftRequestsItem.scss';

const b = block('gifts-requests-item-desktop');

const GiftRequestsItem = ({ item, onChange, handleSetAddressModalOpen }) => {
  const locale = useSelector(s => s.locale.locale);

  const selectItems = statuses.map(t => ({
    ...t,
    renderElement: locale[t.renderElement],
    selectedRenderElement: locale[t.selectedRenderElement],
    active: t.value === item.status,
  }));

  const handleStatusChange = selectItems => {
    onChange(item, selectItems);
  };

  const formatUserInfo = (item) => {
    const { name, last_name, dni, phone, address } = item;
    return `Nombre: ${name || ''} , Apellido: ${last_name || ''} , DNI: ${dni || ''} , Phone: ${phone || ''} , Dirección: ${address || ''}`;
  };

  return (
    <section className={b()}>
      <div className={b('item')}>{item.id}</div>
      <div className={b('item')}>{item.date}</div>
      <div className={b('item')}>{item.username}</div>
      <div className={b('item')}>{item.giftName}</div>
      <div className={b('item', { status: item.status })}>{formatePoints(item.points, 2)}</div>
      <div className={b('item')}>
        <Select color="forGifts" items={selectItems} onChange={handleStatusChange} />
      </div>
      <div onClick={() => handleSetAddressModalOpen(formatUserInfo(item))} className={b('item', { type: 'comment' })}>
        <div className={b('comment')}>{formatUserInfo(item)}</div>
      </div>
    </section>
  );
};

export default GiftRequestsItem;
